<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm4>
                <v-text-field
                  name="saleNo"
                  label="Invoice No."
                  type="text"
                  :rules="rules.invoiceNoRules"
                  v-model="queryParams.saleNo"
                ></v-text-field>
              </v-flex>
              <v-flex sm4>
                <v-btn outline color="primary" @click="onSearch">
                  Search
                  <v-icon right>search</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        <v-flex xs12></v-flex>
        <v-flex xs12>
          <v-card v-if="sale.id">
            <v-layout row wrap class="pa-3">
              <v-flex xs4>
                <div class="text-xs-left">
                  <p class="font-weight-bold">Invoice No.</p>
                  <p class="font-weight-bold">{{sale.saleNo}}</p>
                </div>
              </v-flex>
              <v-flex xs8>
                <div class="text-xs-right">
                  <v-btn color="primary" @click="confirmBox=true">
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                  <v-btn color="error" @click="init()">
                    Cancel
                    <v-icon right>cancel</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
            <div class="text-xs-left pa-3">
              <h3 class="font-weight-bold">Sale Items</h3>
            </div>
            <v-layout row wrap class="light--text pa-3" style>
              <v-flex xs3>Code</v-flex>
              <v-flex xs5>Stock Name</v-flex>
              <v-flex xs1>Price</v-flex>
              <v-flex xs1>Amount</v-flex>
              <v-flex xs1>Qty</v-flex>
              <v-flex xs1>Return Qty</v-flex>
            </v-layout>
            <v-layout
              row
              wrap
              v-for="(saleItem, index) in sale.notFocItems"
              :key="index"
              class="pa-3"
              style="margin-top: -30px"
            >
              <v-flex xs3>
                <v-text-field
                  v-model="saleItem.productCode"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  :readonly="true"
                ></v-text-field>
              </v-flex>
              <v-flex xs5>
                <v-text-field
                  v-model="saleItem.productName"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  :readonly="true"
                ></v-text-field>
              </v-flex>

              <v-flex xs1>
                <v-text-field
                  v-model="saleItem.unitPrice"
                  type="number"
                  min="0"
                  oninput="this.value = Math.abs(this.value)"
                  :readonly="true"
                ></v-text-field>
              </v-flex>
              <v-flex xs1>
                <v-text-field
                  :value="saleItem.unitPrice * saleItem.qty"
                  type="number"
                  min="0"
                  :readonly="true"
                ></v-text-field>
              </v-flex>

              <v-flex xs1>
                <v-text-field
                  v-model="saleItem.qty"
                  min="0"
                  oninput="this.value = Math.abs(this.value)"
                  :readonly="true"
                ></v-text-field>
              </v-flex>

              <v-flex xs1 v-if="sale.id">
                <v-text-field
                  v-model="saleItem.returnQty"
                  min="0"
                  :rules="rules.qtyRules"
                  oninput="this.value = Math.abs(this.value)"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <div class="text-xs-left pa-3">
              <h3 class="font-weight-bold">FOC Items</h3>
            </div>

            <v-layout row wrap class="light--text pa-3">
              <v-flex xs3>Code</v-flex>
              <v-flex xs6>Stock Name</v-flex>
              <v-flex xs1>Price</v-flex>
              <v-flex xs1>Amount</v-flex>
              <v-flex xs1>Qty</v-flex>
            </v-layout>

            <v-layout
              row
              wrap
              v-for="(saleItem, index) in sale.focItems"
              :key="index"
              class="pa-3"
              style="margin-top: -30px"
            >
              <v-flex xs3>
                <v-text-field
                  v-model="saleItem.productCode"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  :readonly="true"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="saleItem.productName"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  :readonly="true"
                ></v-text-field>
              </v-flex>

              <v-flex xs1>
                <v-text-field
                  v-model="saleItem.unitPrice"
                  type="number"
                  min="0"
                  oninput="this.value = Math.abs(this.value)"
                  :readonly="true"
                ></v-text-field>
              </v-flex>
              <v-flex xs1>
                <v-text-field
                  :value="saleItem.unitPrice * saleItem.qty"
                  type="number"
                  min="0"
                  :readonly="true"
                ></v-text-field>
              </v-flex>

              <v-flex xs1>
                <v-text-field
                  v-model="saleItem.qty"
                  type="number"
                  min="0"
                  oninput="this.value = Math.abs(this.value)"
                  :readonly="true"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <v-dialog v-model="messageDialogBox" max-width="500px" @keydown.enter="messageDialogBox=false">
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="error" :value="true">
              <h3>{{ responseError }}</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="messageDialogBox=false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="confirmBox"
      max-width="500px"
      @keydown.enter="reprintSaleDetail('printSale')"
      @keydown.esc="open = false"
    >
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="warning" :value="true">
              <h3>Are you sure to save this sale return?</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="confirmBox=false">Cancel</v-btn>
          <v-btn
            color="success"
            large
            outline
            @click="reprintSaleDetail('printSale')"
            :loading="saveLoading"
          >Proceed</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div
      v-if="sale.id"
      style="font-size: 13px!important"
      v-show="false"
      id="printSale"
      :data="sale"
    >
      <div style="bsale:1px solid black;width:300px;">
        <div style="text-align:center">
          <p style="font-size:11px;margin:0px">{{sale.shopName}}</p>
        </div>
        <div style="text-align:center">
          <p style="font-size:11px;margin:0px">{{sale.shopAddress}}</p>
        </div>
        <div style="text-align:center">
          <p style="font-size:11px;margin:0px">Tel: {{sale.shopPhoneNo}}</p>
        </div>
        <div style="text-align:center">
          <p style="font-size:11px;margin:0px">Invoice #: {{sale.saleNo}}</p>
        </div>
        <div style="text-align:center">
          <p
            style="font-size:11px;margin:0px"
            id="date"
          >{{ sale.createdDateInMilliSeconds | format-ms-custom-date }}</p>
        </div>
        <div style="text-align:center">
          <p style="font-size:11px;font-weight:bold;margin:0px">REPRINT</p>
        </div>
        <div style="float:left;padding-left:11px">
          <p style="font-size:11px;margin:0px" id="counter">Counter: {{sale.counter.name}}</p>
        </div>
        <div style="float:right;padding-right:11px">
          <p style="font-size:11px;margin:0px" id="casher">Casher: {{sale.createdBy}}</p>
        </div>
        <div style="float:right;padding-right:22px">
          <p style="font-size:11px;margin:0px" id="casher">Currency: {{sale.currencyCode}}</p>
        </div>
        <div style="clear:both"></div>
        <div style="height:10px"></div>
        <div style="padding-left:5px;padding-right:5px">
          <table
            style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
          >
            <thead style="border-bottom:1px solid black;border-top:1px solid black">
              <tr>
                <th style="text-align:left"></th>
                <th style="text-align:center">Unit</th>
                <th style="text-align:center">Qty</th>
                <th style="text-align:right">Price</th>
                <th style="text-align:right">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in sale.notFocItems" :key="index">
                <td style="text-align:left">{{item.product.name}}</td>
                <td style="text-align:center">{{item.productUnit.factorUnitName}}</td>
                <td style="text-align:center">{{item.qty | decFormat(6) }}</td>
                <td style="text-align:right">{{item.unitPrice | decFormat(6)}}</td>
                <td style="text-align:right">{{item.qty * item.unitPrice| decFormat(6)}}</td>
              </tr>
            </tbody>
          </table>
          <div style="height:10px"></div>
          <table
            style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;border-top:1px solid black"
          >
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Total Amount</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
              >{{sale.totalAmount | decFormat(6)}}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Tax ({{sale.taxType}})</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
              >{{sale.taxAmount | decFormat(6)}}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Discount Amount</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
                v-if="sale.discountAmount > 0"
              >{{sale.discountAmount | decFormat(6)}}</td>
              <td style="text-align:right;font-weight:bold;font-size:11px" v-else>0</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Net Amount</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
              >{{sale.netAmount | decFormat(6)}}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Received</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
              >{{sale.netAmount + sale.payChange | decFormat(6)}}</td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td style="text-align:right;font-weight:bold;font-size:11px">Pay Change</td>
              <td
                style="text-align:right;font-weight:bold;font-size:11px"
              >{{sale.payChange | decFormat(6)}}</td>
            </tr>
          </table>
        </div>
        <!-- FOC Items -->
        <div style="clear:both"></div>
        <div style="height:10px"></div>
        <div style="padding-left:5px;padding-right:5px" v-if="sale.focItems.length > 0">
          <table
            style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
          >
            <thead style="border-bottom:1px solid black;border-top:1px solid black">
              <tr>
                <th style="text-align:left">FOC Items</th>
                <th style="text-align:center">Unit</th>
                <th style="text-align:center">Qty</th>
                <th style="text-align:right">Price</th>
                <th style="text-align:right">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in sale.focItems" :key="index">
                <td style="text-align:left">{{item.product.name}}</td>
                <td style="text-align:center">{{item.productUnit.factorUnitName}}</td>
                <td style="text-align:center">{{item.qty | decFormat(6) }}</td>
                <td style="text-align:right">{{item.unitPrice | decFormat(6)}}</td>
                <td
                  style="text-align:right"
                >{{item.qty * item.unitPrice | decFormat(6)}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Return Items -->
        <div style="clear:both"></div>
        <div style="height:10px"></div>
        <div style="padding-left:5px;padding-right:5px" v-if="sale.returnItems.length > 0">
          <table
            style="font-family: arial, sans-serif;border-collapse: collapse;width: 100%;font-size:11px;"
          >
            <thead style="border-bottom:1px solid black;border-top:1px solid black">
              <tr>
                <th style="text-align:left">Return Items</th>
                <th style="text-align:center">Unit</th>
                <th style="text-align:center">Qty</th>
                <th style="text-align:right">Price</th>
                <th style="text-align:right">Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in sale.returnItems" :key="index">
                <td style="text-align:left">{{item.product.name}}</td>
                <td style="text-align:center">{{item.productUnit.factorUnitName}}</td>
                <td style="text-align:center">{{item.returnQty | decFormat(6) }}</td>
                <td style="text-align:right">{{item.unitPrice | decFormat(6)}}</td>
                <td
                  style="text-align:right"
                >{{item.returnQty * item.unitPrice | decFormat(6)}}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style="text-align: right;" v-if="user.signature">
          <div style="display: inline-block;">
            <img style="height: 100px;width: 100px;display:block;" :src="user.signature" />
            <span style="display:block;">------------------</span>
            <span style="display:block;text-align:center;font-size:11px;">Signature</span>
          </div>
        </div>
        <div style="text-align:center">
          <p style="font-size:11px;">Thank You! Please Come Again.</p>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { saleReturnService } from "../../services/sale-return-service";
import { Sale } from "../../models/model";
import { saleService } from "../../services/sale-service";
import { SaleReturnFormRules } from "../../helpers/validation-rules";
import { commonService } from "../../services/common-service";

export default {
  name: "SaleReturn",

  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    showListLoading: false,
    breadcrumbs: [
      {
        text: "Sale",
        disabled: true,
      },
      {
        text: "Sale Return",
        disabled: true,
      },
    ],
    confirmBox: false,
    saveLoading: false,
    messageDialogBox: false,
    confirmDialogBox: false,
    invoiceNoDialogBox: false,
    responseError: "",
    sale: new Sale(),
    saleItems: [],
    totalRows: 0,
    decimalFormat: "",
    rules: new SaleReturnFormRules(),
    queryParams: {
      saleNo: "",
    },
  }),
  watch: {
    pagination: {
      handler() {
        this.getSaleList();
      },
      deep: true,
    },
  },
  created() {
    this.decimalFormat = commonService.formatdecimal();
    this.init();
  },
  methods: {
    init() {
      this.sale = new Sale();
      this.queryParams.saleNo = "";
    },

    onSearch() {
      if (this.queryParams.saleNo.trim() == "") {
        this.responseError = "Invoice No. can't be blank.";
        this.messageDialogBox = true;
      } else {
        this.$router.replace({
          name: "sale-return",
          query: this.queryParams,
        });
        this.getSaleList();
      }
    },
    getSaleList() {
      this.showListLoading = true;
      saleReturnService
        .getSaleList(this.queryParams)
        .then((res) => {
          if (res.data) {
            this.sale = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
            this.messageDialogBox = true;
          }
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    reprintSaleDetail(divName) {
      let total = 0;
      this.sale.notFocItems.forEach((item) => {
        item.totalPrice = item.returnQty * item.unitPrice;
        total += item.totalPrice;
      });
      this.sale.totalReturnAmount = total;
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        saleService
          .returnSale(this.sale)
          .then((res) => {
            this.sale = res.data;
            this.saveLoading = false;
            this.confirmDialogBox = false;
          })
          .then(() => {
            this.confirmBox = false;
            var printContents = document.getElementById(divName).innerHTML;
            var reprintWindow = window.open(
              "",
              "MsgWindow",
              "width=500,height=500"
            );
            reprintWindow.document.write(printContents);
            setTimeout(() => {
              reprintWindow.print();
              reprintWindow.close();
            }, 600);
            this.init();
          })
          .catch((err) => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
              this.messageDialogBox = true;
            }
            this.saveLoading = false;
          });
      }
    },
  },
};
</script>